module.exports = __webpack_public_path__ + "static/media/3d-controls-icon.cb40f90a.svg";